<template>
   <div id="main">
      <div>
         <span class="avatar"><img src="../images/avatar.jpg" width="150 px" height="150 px" alt="avatar" /></span>
         <h1>{{name}}</h1>
         <p>{{position}}</p>
      </div>
      <div>
         <ul class="icons">
            <li><a :href="facebook" target="_blank" class="icon brands fa-facebook-f">Facebook</a></li>
            <li><a :href="line" target="_blank" class="icon brands fa-line">Line</a></li>
            <li><a :href="ig" target="_blank" class="icon brands fa-instagram">Instagram</a></li>
         </ul>
      </div>
   </div>
</template>

<style scoped>
   #main{
      width: 45rem;
   }
</style>

<script>
import { mapGetters } from 'vuex';

export default {
   computed : Object.assign(
      {
         
      },
      mapGetters([
         'name','position','facebook','line','ig'
      ]))
}
</script>


// WEBPACK FOOTER //
// src/components/mainPage.vue